export default {"src":"/_next/static/media/kohlrabi.83aaf63f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};